import { useEffect } from "react";
import { useFocusableElements } from "./useFocusableElements.js";
import { getDocumentActiveElement } from "../utils/focus.js";
const useFocusTrap = (ref, trapFocus = true) => {
  const focusableElementList = useFocusableElements(ref);
  const handleKeyboardEvent = (e) => {
    if (trapFocus && ref.current && (focusableElementList == null ? void 0 : focusableElementList.length) && e.key === "Tab") {
      const activeElement = getDocumentActiveElement(ref.current);
      const firstElement = focusableElementList[0];
      const lastElement = focusableElementList.length === 1 ? firstElement : focusableElementList[focusableElementList.length - 1];
      if (e.shiftKey && activeElement === firstElement) {
        lastElement.focus();
        e.preventDefault();
      } else if (!e.shiftKey && activeElement === lastElement) {
        firstElement.focus();
        e.preventDefault();
      }
    }
  };
  useEffect(() => {
    var _a;
    (_a = ref.current) == null ? void 0 : _a.addEventListener("keydown", handleKeyboardEvent);
    return () => {
      var _a2;
      (_a2 = ref.current) == null ? void 0 : _a2.removeEventListener("keydown", handleKeyboardEvent);
    };
  }, [ref, trapFocus, focusableElementList]);
};
export {
  useFocusTrap as default,
  useFocusTrap
};
//# sourceMappingURL=useFocusTrap.js.map
